/**
 * Equations — Arithmetik & Algebra-Rätsel.
 * Universelle Rechenoperationen (Punkt vor Strich, Quadrate, Wurzeln).
 */
export const EQUATIONS = [
  { id: 'eq01', cat: 'equations', diff: 1,
    q: 'Wie viel ist 7 + 8?', a: '15',
    hint: 'Einfache Addition', exp: '7 + 8 = 15' },

  { id: 'eq02', cat: 'equations', diff: 1,
    q: 'Wie viel ist 12 × 4?', a: '48',
    hint: '12 mal 4', exp: '12 × 4 = 48' },

  { id: 'eq03', cat: 'equations', diff: 1,
    q: 'Was fehlt? 9 + ? = 17', a: '8',
    hint: '17 − 9', exp: '17 − 9 = 8' },

  { id: 'eq04', cat: 'equations', diff: 1,
    q: 'Wie viel ist 100 − 37?', a: '63',
    hint: 'Subtraktion', exp: '100 − 37 = 63' },

  { id: 'eq05', cat: 'equations', diff: 2,
    q: 'Wie viel ist 12 + 8 × 2?', a: '28',
    hint: 'Punkt vor Strich', exp: '8·2 = 16, 12+16 = 28' },

  { id: 'eq06', cat: 'equations', diff: 2,
    q: 'Wie viel ist (6 + 4) × 3 − 5?', a: '25',
    hint: 'Klammer zuerst', exp: '10·3 = 30, 30−5 = 25' },

  { id: 'eq07', cat: 'equations', diff: 2,
    q: 'Was fehlt? 3 × ? − 4 = 17', a: '7',
    hint: 'Rückwärts: 17+4, dann ÷3', exp: '(17+4)/3 = 21/3 = 7' },

  { id: 'eq08', cat: 'equations', diff: 2,
    q: 'Wie viel ist 144 ÷ 12?', a: '12',
    hint: 'Quadrat von 12', exp: '12² = 144, also 144/12 = 12' },

  { id: 'eq09', cat: 'equations', diff: 3,
    q: 'Wie viel ist die Hälfte von einem Viertel von 200?', a: '25',
    hint: 'In Schritten denken', exp: '200/4 = 50, 50/2 = 25' },

  { id: 'eq10', cat: 'equations', diff: 3,
    q: 'Was fehlt? ?² + 5 = 30', a: '5',
    hint: 'Quadrat ermitteln', exp: '?² = 25, also ? = 5' },

  { id: 'eq11', cat: 'equations', diff: 3,
    q: 'Wie viel ist 15² − 14²?', a: '29',
    hint: '(a−b)(a+b)', exp: '(15−14)(15+14) = 1·29 = 29' },

  { id: 'eq12', cat: 'equations', diff: 3,
    q: 'Was fehlt? 2 · ? + 3 · ? = 25', a: '5',
    hint: '5·? = 25', exp: '(2+3)·? = 25 → ? = 5' },

  { id: 'eq13', cat: 'equations', diff: 3,
    q: 'Wie viel ist √196?', a: '14',
    hint: 'Quadratwurzel', exp: '14·14 = 196' },

  { id: 'eq14', cat: 'equations', diff: 4,
    q: 'Wie viele Nullen hat 50! am Ende?', a: '12',
    hint: 'Wie oft kommt der Faktor 5 vor?', exp: '50/5 + 50/25 = 10 + 2 = 12' },

  { id: 'eq15', cat: 'equations', diff: 4,
    q: 'Wie viel ist 2¹⁰?', a: '1024',
    hint: 'Verdoppeln', exp: '2·2·2·2·2·2·2·2·2·2 = 1024' },

  { id: 'eq16', cat: 'equations', diff: 2,
    q: 'Wie viel ist 7 × 9 + 7?', a: '70',
    hint: 'Ausklammern', exp: '7·(9+1) = 7·10 = 70' },

  { id: 'eq17', cat: 'equations', diff: 4,
    q: 'Welche Zahl erfüllt: ? + ?·? = 30, wenn alle gleich?', a: '5',
    hint: 'x + x² = 30', exp: 'x² + x − 30 = 0 → (x−5)(x+6) = 0 → x = 5' },

  { id: 'eq18', cat: 'equations', diff: 2,
    q: 'Wie viel ist 18 ÷ 3 + 4 × 2?', a: '14',
    hint: 'Punkt vor Strich', exp: '6 + 8 = 14' },

  { id: 'eq19', cat: 'equations', diff: 3,
    q: 'Was fehlt? (?+1)² = 49', a: '6',
    hint: 'Wurzel ziehen', exp: '?+1 = 7 → ? = 6' },

  { id: 'eq20', cat: 'equations', diff: 1,
    q: 'Wie viel ist 25 × 4?', a: '100',
    hint: 'Viertel zum Ganzen', exp: '25·4 = 100' },
];
